// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .ngx-mat-popover {
  min-width: inherit;
  width: none !important;
  max-width: inherit !important;
}
::ng-deep .ngx-mat-popover .mat-mdc-menu-item {
  height: auto;
  white-space: normal;
  line-height: inherit;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
}
::ng-deep .ngx-mat-popover .mat-mdc-menu-item.cdk-program-focused:not([disabled]), ::ng-deep .ngx-mat-popover .mat-mdc-menu-item:hover:not([disabled]) {
  background: inherit;
}
::ng-deep .ngx-mat-popover .mat-mdc-menu-content {
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/tooltip/ngx-mat-popover/ngx-mat-popover.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,sBAAA;EACA,6BAAA;AACF;AACE;EACE,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;AACJ;AACI;EAEE,mBAAA;AAAN;AAIE;EACE,UAAA;AAFJ","sourcesContent":["::ng-deep .ngx-mat-popover {\r\n  min-width: inherit;\r\n  width: none !important;\r\n  max-width: inherit !important;\r\n\r\n  .mat-mdc-menu-item {\r\n    height: auto;\r\n    white-space: normal;\r\n    line-height: inherit;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    padding: 1rem;\r\n\r\n    &.cdk-program-focused:not([disabled]),\r\n    &:hover:not([disabled]) {\r\n      background: inherit;\r\n    }\r\n  }\r\n\r\n  .mat-mdc-menu-content {\r\n    padding: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
